import {
  Children,
  cloneElement,
  FC,
  isValidElement,
  ReactNode,
  useState,
} from "react";
import styles from "./title-bar-wrapper.module.scss";

interface Props {
  children: ReactNode;
  closeFunction: () => void;
  title: string;
  className?: string;
}

/**
 * This adds a blue title bar at the top of the modal with a close button in the left corner
 */
export const TitleBarWrapper: FC<Props> = ({
  children,
  closeFunction,
  title,
  className,
}) => {
  const [showWrapper, setShowWrapper] = useState(true);

  // Pass a function to to the children that allow them to toggle if this wrapper should be visible
  const childrenWithToggle = Children.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElement(child, {
        toggleWrapper: () => setShowWrapper(false),
      });
    }
    return null;
  });
  return (
    <>
      {showWrapper && (
        <div className={`subtitle02 ${styles.header} ${className}`}>
          <button type="button" onClick={(): void => closeFunction()}>
            &times;
          </button>
          {title}
        </div>
      )}
      {childrenWithToggle}
    </>
  );
};
